module.exports = __webpack_public_path__ + "img/cashdrawer.4bf27df9.jpg";